import {Injectable} from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {ICriterion} from '../../system-configuration/logs/logs.types';
import {FormGroup} from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class SortService {

    constructor() {
    }


    dropSortCriterion(
        event: CdkDragDrop<string[]>,
        form: FormGroup,
        selectedSortCriteria: ICriterion[]
    ) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
            const sortByControl = form.get('sort_by');
            sortByControl.setValue(sortByControl.value || []);
            sortByControl.setValue(selectedSortCriteria.map((criterion: ICriterion) => criterion.slug));
        }
    }

    removeSortCriterion(
        criterion: ICriterion,
        form: FormGroup,
        selectedSortCriteria: ICriterion[],
        sortCriteria: ICriterion[]
    ) {
        const selectedIndex = selectedSortCriteria.indexOf(criterion);
        selectedSortCriteria.splice(selectedIndex, 1);

        sortCriteria.unshift(criterion);
        form.get('sort_by').setValue(selectedSortCriteria.map((c: ICriterion) => c.slug));
    }
}
